// Models
import Model from './Model'

class AccountUser extends Model {
  get schema () {
    return [
      'email',
      'id',
      'locale',
      'loggedIn',
      'mainPhoneNumber',
      'phoneConfirmed',
      'smsProvider',
      'tfaChangedAt',
      'tfaEnabled',
      'twoFactorAuthenticationType',
      'version'
    ]
  }
}

export default AccountUser
